import type { ComponentProps } from 'react'
import { twMerge } from 'tailwind-merge'

export type DialogIconTone = 'neutral' | 'danger'

interface DialogIconProps extends ComponentProps<'span'> {
  /** `danger` for dialogs that take something away. */
  tone?: DialogIconTone
}

const TONE_CLASS_NAME: Record<DialogIconTone, string> = {
  neutral: 'bg-element text-foreground',
  danger: 'bg-danger-subtle text-danger-subtle',
}

/** What the dialog is about, in a tile over its title. Goes first inside Header. */
export function DialogIcon({ tone = 'neutral', className, children, ...props }: DialogIconProps) {
  return (
    <span
      aria-hidden="true"
      data-dialog-icon=""
      className={twMerge(
        'corner-squircle mb-3 grid size-9 shrink-0 place-items-center rounded-[18px] [&>svg]:size-5',
        TONE_CLASS_NAME[tone],
        className,
      )}
      {...props}
    >
      {children}
    </span>
  )
}
